<script setup lang="ts">
import NamaIcon from "@/components/icons/NamaIcon.vue"
import {Dialog} from "quasar";
import EditUiElementPropertiesDialog from "@/components/dialogs/EditUIElementPropertiesDialog.vue";
import {storeToRefs} from "pinia";
import {useNamaFlagsStore} from "@/stores/nama-flags-store.ts";
import {IHeaderParams} from "ag-grid-enterprise";
import TitledID = namaTypes.TitledID;
import GUIActionPlaceholder = namaTypes.GUIActionPlaceholder;

const {showEditUIElementProperties} = storeToRefs(useNamaFlagsStore())
const props = defineProps<{ blockOrField?: TitledID, agHeaderParams?: IHeaderParams, actionInfo?: GUIActionPlaceholder, entityType?: string }>()

function onClick() {
  Dialog.create({
    component: EditUiElementPropertiesDialog,
    componentProps: props
  })
}
</script>

<template>
  <div v-if="showEditUIElementProperties" class="tw-p-1 tw-cursor-pointer tw-h-fit" @click.stop="onClick">
    <NamaIcon default-icon="nm-edit-text"
              class="active-primary tw-size-5"/>
  </div>
</template>
